import { render } from "./ProdottiAcquistati.vue?vue&type=template&id=f922d192&scoped=true"
import script from "./ProdottiAcquistati.vue?vue&type=script&lang=js"
export * from "./ProdottiAcquistati.vue?vue&type=script&lang=js"

import "./ProdottiAcquistati.vue?vue&type=style&index=0&id=f922d192&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f922d192"]])

export default __exports__